import React from "react";
import CreateCustomMessage from "../../components/CreateCustomMessage/CreateCustomMessage";
import CustomMessageList from "../../components/CustomMessageList/CustomMessageList";
import TeacherMessage from "../../components/TeacherMessage/TeacherMessage";
import "./styles.css";

const RandomMessageScreen = () => {
  return (
    <>
      <div className="custom-message-screen-container">
        <TeacherMessage />
        <CreateCustomMessage />
        <CustomMessageList />
      </div>
    </>
  );
};

export default RandomMessageScreen;
